var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinFormulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12988 4.2446L4.31249 2.93848L0.869014 3.91807V5.87725L7.12988 4.2446Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12988 8.16354L4.31249 6.85742L0.869014 7.83701V9.7962L7.12988 8.16354Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12988 12.0815L4.62554 10.7754L0.869014 11.755V13.7142L7.12988 12.0815Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.869141 1.95918V0L7.13001 2.28571V4.2449L0.869141 1.95918Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.869141 5.87715V3.91797L7.13001 6.20368V8.16287L0.869141 5.87715Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.869141 9.7961V7.83691L7.13001 10.1226V12.0818L0.869141 9.7961Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.869141 13.7141V11.7549L7.13001 14.0406V15.9998L0.869141 13.7141Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinFormulation);
export default __webpack_public_path__ + "static/media/ProteinFormulation.8894f8451c8057b543998d6103749271.svg";
export { ForwardRef as ReactComponent };